export default content => ({
  title: content.title,
  subtitle: content.subtitle
});
